import { handleError } from "core/utils/HandleError"
import { handleResponse } from "core/utils/HandleResponse"
import { AuthHttpClient } from "core/utils/HttpClient"

export function getStores(params: any) {
  return AuthHttpClient
    .get('/stores/seagm/catalogue', { params })
    .then(handleResponse)
    .catch(handleError)
}

export function getStoreById(storeId: string | number) {
  return AuthHttpClient
    .get(`/stores/seagm/catalogue/${storeId}`)
    .then(handleResponse)
    .catch(handleError)
}

export function addStore(data: any) {
  return AuthHttpClient
    .post('/stores/seagm/catalogue', data)
    .then(handleResponse)
    .catch(handleError)
}

export function updateStore(data: any,storeId: string | number) {
    return AuthHttpClient
      .patch(`/stores/seagm/catalogue/${storeId}`, data)
      .then(handleResponse)
      .catch(handleError)
  }

export function deleteSeagmProduct(storeId: string | number) {
  return AuthHttpClient
    .delete(`/stores/seagm/catalogue/${storeId}`)
    .then(handleResponse)
    .catch(handleError)
}
